@let currentTab = activeTab();

<app-card-page [isEmbeddedInModal]="true">
  <span header>Settings</span>

  <div pageactionssecondary class="flex items-center gap-2">
    <app-button-connect></app-button-connect>

    <app-button-close appModalClose></app-button-close>
  </div>

  <div role="tablist" class="tabs tabs-box">
    @for (tab of tabs; track $index) {
      <button
        role="tab"
        class="tab"
        [class.tab-active]="currentTab === tab.link"
        [class.tab-debug]="tab.link === 'Debug'"
        (click)="changeActiveTab(tab.link)"
        (keydown)="changeActiveTab(tab.link)"
        [appAnalyticsClick]="'Options:Navigate:' + tab.name"
        [class.hidden]="!tab.showIf()"
        appSfx="ui-click"
        [sfxTrigger]="['click', 'hover']"
      >
        {{ tab.name }}
      </button>
    }
  </div>

  <div class="p-3 h-[calc(100%-60px)] overflow-y-auto">
    @switch (currentTab) {
      @case ('UI') {
        <app-panel-options-ui></app-panel-options-ui>
      }

      @case ('Accessibility') {
        <app-panel-options-accessibility></app-panel-options-accessibility>
      }

      @case ('Debug') {
        <app-panel-options-debug></app-panel-options-debug>
      }

      @case ('Savefile') {
        <app-panel-options-savefile></app-panel-options-savefile>
      }

      @case ('Misc') {
        <app-panel-options-misc></app-panel-options-misc>
      }
    }
  </div>
</app-card-page>
